export const LOCALES = {
  EN: 'en',
  RU: 'ru',
} as const;
